import { css, styled } from 'styled-components'
import {
  onExtraLargeScreen,
  onLargeScreen,
  onMediumScreen,
  onXXLargeScreen,
} from '../../../../mixtiles-web-common'
import Marquee from 'react-fast-marquee'

const limitWidthContainer = css`
  ${onMediumScreen()} {
    max-width: 100%;
    margin: auto;
    overflow: unset;
  }

  ${onLargeScreen()} {
    max-width: 1100px;
  }

  ${onExtraLargeScreen()} {
    max-width: 1300px;
  }

  ${onXXLargeScreen()} {
    max-width: 1500px;
  }
`

export const Container = styled.div`
  height: 78vh;
  width: 100%;
  background: ${({ theme }) => `linear-gradient(
    to bottom,
    ${theme.colors.grayMedium},
    ${theme.colors.grayBackgroundWhite}
  )`};

  ${onMediumScreen()} {
    height: 83vh;
    background: ${({ theme }) => theme.colors.grayBackgroundWhite};
    margin-bottom: 50px;
  }
`

export const TitleText = styled.h1`
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-size: 42px;
  line-height: 1.1;
  max-width: 376px;
  letter-spacing: -0.005em;
  font-style: normal;
  font-weight: 600;
  white-space: break-spaces;
  margin: 52px auto 12px;

  ${onMediumScreen()} {
    font-size: 54px;
    white-space: initial;
    max-width: unset;
  }

  ${onLargeScreen()} {
    margin: 88px auto 12px;
  }
`

export const SubtitleText = styled.h2`
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-size: 18px;
  line-height: 1.1;
  font-weight: 400;
  max-width: 340px;
  margin: 0 auto 40px;

  ${onMediumScreen()} {
    max-width: unset;
  }

  ${onExtraLargeScreen()} {
    font-size: 24px;
  }
`

export const ArtworksContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: fit-content;

  ${limitWidthContainer};
`

export const SliderRow = styled(Marquee).attrs({
  delay: 0.5,
})`
  pointer-events: none;
  max-width: 100vw;
`

// Stretch artworks to fill possible height (the available space below the title). Divide by 2 because there are 2 lines of artworks.
export const ArtworkContainer = styled.div<{
  $height: number
  $width: number
}>`
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
`

export const GradientContainer = styled.div`
  ${limitWidthContainer};
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
  top: 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100px;
    background: linear-gradient(
      -90deg,
      #fbf6f6 0%,
      rgba(251, 246, 246, 0) 0.01%,
      #fbf6f6 100%
    );
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100px;
    background: linear-gradient(
      90deg,
      #fbf6f6 0%,
      rgba(251, 246, 246, 0) 0.01%,
      #fbf6f6 100%
    );
  }
`
